$(document).ready(function () {
  $("#fullscreen-modal .close-media-modal").on("click", function() {
    $("#fullscreen-modal .media-item").empty();

    $("#fullscreen-modal").removeClass("animate__zoomIn").addClass("animate__zoomOut");

    setTimeout(function() {
      $("#fullscreen-modal").css({
        "display": "none"
      });
      $("#fullscreen-modal").removeClass("animate__zoomOut").addClass("animate__zoomIn");
    }, 900);
  });
});
